export const jsonDiffTableStyles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    mt: 0.5,
  },
  colHeader: {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: 'gray.56',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  },
  cell: {
    py: 0.75,
    px: 1,
    fontSize: '0.8rem',
    wordBreak: 'break-word' as const,
    borderBottom: '1px solid',
    borderColor: 'gray.8',
  },
  fieldCell: {
    color: 'gray.80',
    fontWeight: 500,
  },
  fromCell: {
    color: 'error.main',
  },
  toCell: {
    color: 'success.main',
  },
  lastRow: {
    '&:last-child td, &:last-child th': { borderBottom: 0 },
  },
  noChanges: {
    fontSize: '0.8rem',
    color: 'gray.40',
    fontStyle: 'italic',
  },
  fieldColWidth: '34%',
  valueColWidth: '33%',
}
